import React from "react";
import { Route } from "react-router-dom";
import AuthNLoginFullCallback from "./authn-login-callback";
import AuthnError from "../authn/authn-error";
import LoginPFWithAgcc from "./autnh-login-pf-agcc-callback/autnh-login-pf-agcc-callback";
import LoginPJChaveJ from "./autnh-login-pj-chavej-callback";
import SelectRelationship from "./authn-select-relationship";
import RegisterPC from "./authn-register-pc";
import LoginGov from "./autnh-login-gov-callback/autnh-login-gov-callback";

const prefix = "/authn";

const routes = [
  <Route
    path={`${prefix}/error`}
    component={AuthnError}
    exact
    key={`${prefix}-error`}
  />,
  <Route
    path={`${prefix}/callback`}
    component={AuthNLoginFullCallback}
    exact
    key={`${prefix}-callback`}
  />,
  <Route
    path={`${prefix}/pf/callback`}
    component={LoginPFWithAgcc}
    exact
    key={`${prefix}-pf-callback`}
  />,
  <Route
    path={`${prefix}/gov/callback`}
    component={LoginGov}
    exact
    key={`${prefix}-gov-callback`}
  />,
  <Route
    path={`${prefix}/pj/select-relationship`}
    component={SelectRelationship}
    exact
    key={`${prefix}-pj-select-relationship`}
  />,
  <Route
    path={`${prefix}/pj/chavej/callback`}
    component={LoginPJChaveJ}
    exact
    key={`${prefix}-pj-chavej-callback`}
  />,
  <Route
    path={`${prefix}/pj/register-pc`}
    component={RegisterPC}
    exact
    key={`${prefix}-pj-register-pc`}
  />,
];

export default routes;
